// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3ziRA","content":"LoadingAlert_content__2LSof"};